import { api } from "@/builders/axios";
import { CreateQuestion } from "@/builders/types/questions";

const get = function (id: number) {
  return api.get<{
    question_bank: number;
    question: string;
    marks: number;
    options: Array<{
      option: string;
      is_answer: boolean;
    }>;
  }>(`questions/${id}`);
};

const put = function (variables: { id: number; data: CreateQuestion }) {
  const { id, data } = variables;
  return api.put(`questions/${id}`, data).then(({ data }) => data);
};

const del = function (id: number) {
  return api.delete(`questions/${id}`);
};

export const id = {
  get,
  put,
  del,
};
